import jp from "./i18n/jp";
import zh from "./i18n/zh";
import en from "./i18n/en";

export default {
    JP: jp,
    ZH: zh,
    EN: en,
};
